import { FC } from 'react';
import { ReactComponent as Video } from 'assets/icons/video.svg';
import { ReactComponent as VideoDark } from 'assets/icons/video_dark.svg';
import { ReactComponent as Speaker } from 'assets/icons/speaker.svg';
import { ReactComponent as SpeakerDark } from 'assets/icons/speaker_dark.svg';
import { ReactComponent as Microphone } from 'assets/icons/microphone.svg';
import { ReactComponent as MicrophoneMuted } from 'assets/icons/microphone_muted.svg';
import { ReactComponent as Hang } from 'assets/icons/hang.svg';
import { ReactComponent as Fullscreen } from 'assets/icons/fullscreen.svg';
import { ReactComponent as FullscreenExit } from 'assets/icons/fullscreen_exit.svg';

import { StyledMeetingAction } from './styled';

const ICONS = {
  video: Video,
  videoDark: VideoDark,
  speaker: Speaker,
  speakerDark: SpeakerDark,
  microphone: Microphone,
  microphoneMuted: MicrophoneMuted,
  hang: Hang,
  fullscreen: Fullscreen,
  fullscreenExit: FullscreenExit
} as const;

interface IProps {
  icon: keyof typeof ICONS;
  isDecline?: boolean;
  isSelected?: boolean;
  isDisabled?: boolean;
  onClick?(): void;
}

const MeetingAction: FC<IProps> = ({
  icon,
  isDecline = false,
  isSelected = false,
  isDisabled = false,
  onClick
}) => {
  const Component = ICONS[icon];

  return (
    <StyledMeetingAction
      $isDecline={isDecline}
      $isSelected={isSelected}
      $isDisabled={isDisabled}
      onClick={isDisabled ? undefined : onClick}
      disabled={isDisabled}
    >
      <Component />
    </StyledMeetingAction>
  );
};

export default MeetingAction;
